var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{ref:"baseModal",attrs:{"size":_vm.size,"align":_vm.align}},[_c('div',{staticClass:"list-modal"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }